/* eslint-disable  @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";

export const useBotmakerScriptLoader = (
  botID: string,
  scriptSelector?: string
) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const iframe = document.querySelector(scriptSelector || "");

  const loadScript = useCallback(() => {
    if (scriptLoaded && iframe) {
      console.log("Script já carregado.");
      iframe.classList.remove("hide-chat");
      return;
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://go.botmaker.com/rest/webchat/p/${botID}/init.js`;
    script.async = true;

    script.onload = () => {
      console.log("Script foi carregado com sucesso.");
      if (typeof (window as any).initEmbeddedMessaging === "function") {
        (window as any).initEmbeddedMessaging();
      }
      setScriptLoaded(true);
    };

    document.body.appendChild(script);
  }, [botID, scriptLoaded]);

  const removeScript = useCallback(() => {
    if (scriptLoaded) {
      const script = document.querySelector(
        `script[src="https://go.botmaker.com/rest/webchat/p/${botID}/init.js"]`
      );

      if (script && iframe) {
        iframe.classList.add("hide-chat");
        console.log("chat escondido com sucesso");
      }
    }
  }, [scriptLoaded]);

  useEffect(() => {
    return () => {
      if (scriptLoaded) {
        const script = document.querySelector(
          `script[src="https://go.botmaker.com/rest/webchat/p/${botID}/init.js"]`
        );
        if (script) {
          document.body.removeChild(script);
          console.log("Script foi removido do DOM.");
        }
      }
    };
  }, [botID, scriptLoaded]);

  return { loadScript, removeScript };
};
